module.exports = __webpack_public_path__ + "img/网络投票.f836a104.png";